// extracted by mini-css-extract-plugin
export default {"sizes":"O1HIm","selectWrapper":"ykp7r"};